export const designImages = {
  1: [
    '/images/design1/thumbnail1.jpg',
    '/images/design1/main.jpg',
    '/images/design1/thumbnail2.jpg',
    '/images/design1/thumbnail3.jpg',
    '/images/design1/thumbnail4.jpg'
  ],
  2: [
    '/images/design2/main.jpg',
    '/images/design2/thumbnail1.jpg',
    '/images/design2/thumbnail2.jpg',
    '/images/design2/thumbnail3.jpg',
    '/images/design2/thumbnail4.jpg'
  ],
  3: [
    '/images/design3/main.jpg',
    '/images/design3/thumbnail1.jpg',
    '/images/design3/thumbnail2.jpg',
    '/images/design3/thumbnail3.jpg',
    '/images/design3/thumbnail4.jpg'
  ],
  4: [
    '/images/design4/main.jpg',
    '/images/design4/thumbnail1.jpg',
    '/images/design4/thumbnail2.jpg',
    '/images/design4/thumbnail3.jpg',
    '/images/design4/thumbnail4.jpg'
  ],
  5: [
    '/images/design5/main.jpg',
    '/images/design5/thumbnail1.jpg',
    '/images/design5/thumbnail2.jpg',
    '/images/design5/thumbnail3.jpg',
    '/images/design5/thumbnail4.jpg'
  ],
  6: [
    '/images/design6/main.jpg',
    '/images/design6/thumbnail1.jpg',
    '/images/design6/thumbnail2.jpg',
    '/images/design6/thumbnail3.jpg',
    '/images/design6/thumbnail4.jpg'
  ],
  7: [
    '/images/design7/main.jpg',
    '/images/design7/thumbnail1.jpg',
    '/images/design7/thumbnail2.jpg',
    '/images/design7/thumbnail3.jpg',
    '/images/design7/thumbnail4.jpg'
  ],
  8: [
    '/images/design8/main.jpg',
    '/images/design8/thumbnail1.jpg',
    '/images/design8/thumbnail2.jpg',
    '/images/design8/thumbnail3.jpg',
    '/images/design8/thumbnail4.jpg'
  ],
  9: [
    '/images/design9/main.jpg',
    '/images/design9/thumbnail1.jpg',
    '/images/design9/thumbnail2.jpg',
    '/images/design9/thumbnail3.jpg',
    '/images/design9/thumbnail4.jpg'
  ],
  10: [
    '/images/design10/main.jpg',
    '/images/design10/thumbnail1.jpg',
    '/images/design10/thumbnail2.jpg',
    '/images/design10/thumbnail3.jpg',
    '/images/design10/thumbnail4.jpg'
  ]
};

export const designNames = {
  1:  "Royal Peacock Ensemble",
  2:  "Artisan's Choice Lehenga",
  3:  "Maharaja's Garden Lehenga",
  4:  "Golden Palace Lehenga",
  5:  "Crafted Harmony Lehenga",
  6:  "Signature Queen's Collection",
  7:  "Timeless Grace Lehenga",
  8:  "Jewel Tone Heritage",
  9:  "Crimson Tapestry Duet",
  10: "Golden Splendor Ensemble"
};

export const designTags = {
  1:  ["Peacock", "Red Silk", "Zardozi"],
  2:  ["Tissue Silk", "Zardozi & Zari", "Dual Embroidery"],
  3:  ["Red Silk", "Heavy Gold Embroidery", "Nature Motifs"],
  4:  ["Golden Theme", "Castle Motifs", "Dual Design"],
  5:  ["Four Motifs", "Elephant & Birds", "Mixed Designs"],
  6:  ["Heritage", "Signature", "Classic"],
  7:  ["Vintage", "Romantic", "Blush"],
  8:  ["Elegant", "Velvet Border", "Heritage"],
  9:  ["Thread Work", "Dual Design", "Heavy Borders"],
  10: ["Contemporary", "Classic", "Subtle"]
};

export const designDescriptions = {
  1:  "A stunning design featuring red silk with intricate peacock borders and delicate floral motives. Hand-embroidered with traditional zardozi embroidery that brings the design to life. Each stitch is carefully crafted to create a regal, sophisticated piece perfect for brides seeking a timeless, culturally rich ensemble.",
  2:  "Crafted on premium tissue silk with exquisite zardozi and zari embroidery, this design seamlessly combines two stunning embroidery techniques. The lehenga features delicate running motifs flowing across the sides with a heavy embroidery design concentrated on the front and back panels. This masterpiece showcases the artisan's expertise in balancing intricate detailing with wearable elegance. Hand-embroidered by master artisans using traditional techniques, it's perfect for the bride seeking a sophisticated design with maximum visual impact and refined craftsmanship.",
  3:  "A regal masterpiece adorned with luxurious red silk and our heaviest hand-embroidered gold embroidery. This design features exquisite palm tree and deer motifs artfully spaced throughout, creating visual drama and sophistication. Hand-stitched with traditional zardozi and zari techniques, every motif showcases meticulous craftsmanship. The matching dupatta is our most elaborate piece yet, fully embellished with the same intricate embroidery. Perfect for the bride seeking an unforgettable, statement-making ensemble with unparalleled opulence and heritage grandeur.",
  4:  "A stunning masterpiece featuring premium tissue silk in a radiant golden theme. This exquisite design showcases two complementary embroidery patterns running simultaneously, with a sophisticated castle-inspired motif that creates a majestic, royal appearance. Hand-stitched with traditional zari techniques, each pattern flows beautifully to create a harmonious yet visually dramatic ensemble. Perfect for the bride seeking an elaborate, show-stopping look with heritage grandeur and modern sophistication.",
  5:  "An exceptional masterpiece featuring four distinct and complementary embroidery designs seamlessly integrated into one magnificent ensemble. Crafted on premium silk, this design showcases: Majestic elephant motifs symbolizing grace and strength, palm tree motifs representing elegance and heritage, delicate bird motifs symbolizing freedom and beauty, and running geometrical designs creating visual rhythm and contemporary appeal. Each motif is hand-stitched with traditional zari and beadwork, flowing harmoniously across the lehenga to create a balanced yet visually stunning composition. The intricate layering of all four designs demonstrates exceptional artisanal skill and modern aesthetic sensibility. Perfect for the bride seeking a unique, multi-dimensional piece that celebrates diverse heritage elements in perfect harmony.",
  6:  "A stunning evolution of our heritage collection featuring a perfect blend of traditional motifs with contemporary silhouette. Hand-stitched embroidery on premium silk creates an elegant statement piece. This design combines the best of our craftsmanship legacy in a versatile, wearable style that honors tradition while embracing modern bridal aesthetics.",
  7:  "Inspired by timeless elegance, this design features delicate vintage embroidery patterns on Premium Silk. Hand-stitched motifs create a romantic aesthetic with subtle sophistication. Perfect for brides seeking a graceful, nostalgic style with modern comfort and refined craftsmanship.",
  8:  "A magnificent masterpiece meticulously embroidered by our finest craftsmen on premium tissue silk fabric. This design features exquisite oxidized zardozi embroidery that creates a sophisticated, jewel-tone aesthetic with luminous depth. The velvet-touch border detailing adds elegant highlighting and dimension throughout, creating a luxurious showcase of refined artisanal craftsmanship. Perfect for the bride seeking opulent, handcrafted elegance with unparalleled detail and heritage finesse.",
  9:  "An exquisite thread work lehenga masterpiece showcasing two distinct embroidery designs running simultaneously across the ensemble. Crafted on premium silk fabric, this design features intricate thread embroidery with meticulous detailing that captures the essence of traditional craftsmanship. The highlight of this piece is the dupatta with its magnificent heavy borders adorned with elaborate embroidery work, creating a striking visual statement. The dual design patterns flow harmoniously, demonstrating exceptional artisanal expertise. Perfect for the bride seeking a sophisticated, multi-layered design with rich textural depth and heritage elegance.",
  10: "A timeless masterpiece celebrating vertical traditional aesthetics with exquisite golden zardozi embroidery on premium silk fabric. This design features elaborate hand-stitched embroidery flowing vertically across the lehenga, creating elegant lines that elongate the silhouette with grace and sophistication. The golden zardozi work showcases traditional motifs arranged in a vertical pattern, reflecting authentic heritage craftsmanship. The dupatta and blouse complement the ensemble with coordinated embroidery details. Perfect for the bride seeking a classic, vertically-inspired traditional look with premium quality and timeless elegance."
};

export const designDetails = {
  1:  { occasion: "Wedding • Bridal", material: "Premium Silk",                              embroidery: "Hand-stitched Zardozi Embroidery & Floral Motives",                          included: "Lehenga, Dupatta, Blouse", timeToCreate: "8-10 weeks" },
  2:  { occasion: "Wedding • Bridal", material: "Premium Tissue Silk",                       embroidery: "Hand-stitched Zardozi & Zari (Running Motifs + Heavy Embroidery)",          included: "Lehenga, Dupatta, Blouse", timeToCreate: "10-14 weeks" },
  3:  { occasion: "Wedding • Bridal", material: "Premium Red Silk, Gold Zari & Zardozi",     embroidery: "Hand-stitched Gold Embroidery (Palm Trees & Deer Motifs)",                  included: "Lehenga, Heavy Embroidered Dupatta, Blouse", timeToCreate: "8-10 weeks" },
  4:  { occasion: "Wedding • Bridal", material: "Premium Tissue Silk, Gold Zari & Zardozi",  embroidery: "Hand-stitched Dual Design Embroidery (Castle Motifs)",                      included: "Lehenga, Dupatta, Blouse", timeToCreate: "10-14 weeks" },
  5:  { occasion: "Wedding • Bridal", material: "Premium Silk, Gold Zari, Pearls, Beads",    embroidery: "Hand-stitched Four Motif Design (Elephant, Palm Trees, Birds, Geometrical)", included: "Lehenga, Dupatta, Blouse", timeToCreate: "14-18 weeks" },
  6:  { occasion: "Wedding • Bridal", material: "Premium Organza Silk",                      embroidery: "Hand-stitched zardozi",                                                     included: "Lehenga, Dupatta, Blouse", timeToCreate: "9-13 weeks" },
  7:  { occasion: "Wedding • Bridal", material: "Premium Silk",                              embroidery: "Hand-stitched Vintage Motifs",                                              included: "Lehenga, Dupatta, Blouse", timeToCreate: "8-12 weeks" },
  8:  { occasion: "Wedding • Bridal", material: "Premium Tissue Silk",                       embroidery: "Hand-stitched Oxidized Embroidery",                                         included: "Lehenga, Dupatta, Blouse", timeToCreate: "10-14 weeks" },
  9:  { occasion: "Wedding • Bridal", material: "Premium Silk, Thread Work Embroidery",      embroidery: "Hand-stitched Dual Thread Work (Two Simultaneous Designs)",                 included: "Lehenga, Dupatta, Blouse", timeToCreate: "10-14 weeks" },
  10: { occasion: "Wedding • Bridal", material: "Premium Silk",                              embroidery: "Hand-stitched Golden Zardozi (Vertical Traditional Pattern)",               included: "Lehenga, Dupatta, Blouse", timeToCreate: "9-12 weeks" }
};

export const TOTAL_DESIGNS = 10;
export const TRENDING_IDS = [1, 3, 5, 10];

// Each design's defining heritage motif — the Rivayat equivalent of Bahaar
// Edit's colour swatch. Rivayat is a house of consistent crimson-and-gold
// craft, not personal colour choice, so its signature is the emblem worked
// into the embroidery rather than a hue.
export const designMotifs = {
  1:  "Peacock & Florals",
  2:  "Zardozi & Zari",
  3:  "Palm & Deer Motifs",
  4:  "Castle Motifs",
  5:  "Four Motifs",
  6:  "Heritage Classic",
  7:  "Vintage Romantic",
  8:  "Velvet & Oxidised",
  9:  "Dual Thread Work",
  10: "Vertical Zardozi"
};

// Two-letter monograms stamped on the wax seal — hand-picked so no two
// designs share a mark. (A single-initial seal collides constantly: designs
// 1 and 3 would both stamp "P", designs 7/8/10 would all stamp "V".)
export const designSeals = {
  1:  "PF",
  2:  "ZZ",
  3:  "PD",
  4:  "CM",
  5:  "FM",
  6:  "HC",
  7:  "VR",
  8:  "VO",
  9:  "DT",
  10: "VZ"
};
